<template>
  <div
    class="license-item com-anm22-app-pointer"
    style="margin-bottom:20px;"
    @click="click"
  >
    <img class="license-img" :src="cover">
    <div class="license-data">
      <div class="license-title">
        <div class="com-anm22-app-text-xl">{{ name }}</div>
      </div>
      <div class="license-subtitle"></div>
      <div
        class="wg-row"
        style="justify-content:space-between;"
      >
        <div v-if="showStatus" class="license-status">
          <div :class="'booking-status ' + (open ? 'open' : 'close')" :title="$anm22.strLang(lang, 'Booking', 'Ordinazioni')">
            <img :src="$anm22.icons.getWorldIcon('public')" />
            {{ open ? $anm22.strLang(lang, "Open", "Aperto") : $anm22.strLang(lang, "Closed", "Chiuso") }}
          </div>
          <div v-if="masterLastPing && masterLastPing > 0" :class="'master-status ' + (($moment.tz(timezone).unix() - masterLastPing) > 600 ? 'warning' : 'active')" :title="$anm22.strLang(lang, 'Printer master', 'Master stampanti')">
            <img :src="$anm22.icons.getWorldIcon('menuRegister')" />
            {{ masterLastPing ? $moment.tz(masterLastPing, 'X', timezone).format('YYYY-MM-DD HH:mm') : "" }}
          </div>
        </div>
        <!--  -->
        <template v-if="services">
          <template v-if="isFoodLicense">
            <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:nowrap;">
              <img v-if="services.table == 1" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getFoodIcon('table')" style="margin-right:5px;opacity:0.5;" />
              <img v-if="services.pickup == 1" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getFoodIcon('pickUpBar')" style="margin-right:5px;opacity:0.5;" />
              <img v-if="services.delivery == 1" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getFoodIcon('delivery')" style="margin-right:5px;opacity:0.5;" />
              <div v-if="!free" style="width:10px;font-size:8px;">ORDINA ONLINE</div>
            </div>
            <div class="com-anm22-app-text-l" :style="{ color: open ? '#4CAF50' : '#F44336'}">
              {{ open ? $anm22.strLang(lang, "Open", "Aperto") : $anm22.strLang(lang, "Closed", "Chiuso") }}
            </div>
          </template>
          <div v-else style="display:flex;align-items:center;justify-content:space-between;flex-wrap:nowrap;">
            <img v-if="services.bar == 1" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getFoodIcon('pickUpBar')" style="margin-right:5px;opacity:0.5;" />
            <img v-if="services.restaurant == 1" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getFoodIcon('table')" style="margin-right:5px;opacity:0.5;" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    cover: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    isFoodLicense: Boolean,
    services: {
      type: Object,
      default: null
    },
    open: {
      type: Boolean,
      default: true
    },
    free: {
      type: Boolean,
      default: false
    },
    click: {
      type: Function,
      default: function(){}
    },
    showStatus: {
      type: Boolean,
      default: false
    },
    masterLastPing: {
      type: Number,
      default: 0
    },
    timezone: {
      type: String,
      default: "Europe/Rome"
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
}
</script>

<style lang="scss" scoped>
.license-item {
  color: #222;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  width: 266px;
  text-align: center;
  display: inline-block;
  margin: 10px;
  border-radius: 6px;
  background-color: #fff;
  &:hover {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
  }
}
.license-img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 118px;
  border-radius: 6px 6px 0 0;
  img {
    border-radius: 6px 6px 0 0;
  }
}
.license-data {
  background-color: #fff;
  padding: 10px 10px 5px 10px;
  overflow: hidden;
  border-radius: 0 0 6px 6px;
}
.license-title {
  color: #222;
  font-size: 16px;
  margin: 0 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.license-subtitle {
  color: #777;
  font-size: 16px;
}
.license-status {
  text-align: center;

  & > div {
    display: inline-block;
    vertical-align: middle;
    color: #333;
    font-size: 12px;
    background-color: #ddd;
    border-radius: 4px;
    padding: 6px 12px 6px 30px;
    position: relative;

    &.booking-status {
      margin-right: 6px;

      &.open {
        color: #4CAF50;
      }
    }
    &.master-status.warning {
      color: #f00;
    }

    img {
      position: absolute;
      top: 5px;
      left: 9px;
      vertical-align: middle;
      margin-right: 6px;
      width:14px;
      opacity: 0.8;
    }
  }
}
</style>
